export function WellbeingScales({ defs, values, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3" data-testid="wellbeing-scales">
      {defs.map((d) => {
        const v = values[d.key] ?? d.default;
        const testId = d.key === "mood" || d.key === "anxiety" ? `${d.key}-slider` : `scale-slider-${d.key}`;
        return (
          <div key={d.key} data-testid={`scale-row-${d.key}`}>
            <div className="flex justify-between text-xs font-semibold text-stone-600 mb-0.5">
              <span>{d.label}</span>
              <span className="font-mono text-amber-800" data-testid={`scale-value-${d.key}`}>{v}/10</span>
            </div>
            <input
              type="range"
              min="1"
              max="10"
              data-testid={testId}
              value={v}
              onChange={(e) => onChange(d.key, +e.target.value)}
              className="w-full accent-amber-600"
            />
            <div className="flex justify-between text-[10px] text-stone-400 -mt-0.5">
              <span>{d.low}</span>
              <span>{d.high}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
